/**
 * The action dispatched when the {@link NetworkInfo} structure is being updated.
 *
 * @type {string}
 */
export const SET_NETWORK_INFO = 'SET_NETWORK_INFO';
/**
 * The action dispatched by 'base/net-info' middleware in order to store the cleanup function for later use.
 * @type {string}
 * @private
 */
export const _STORE_NETWORK_INFO_CLEANUP = 'STORE_NETWORK_INFO_CLEANUP';
